module.exports = __webpack_public_path__ + "static/innere-wunde-6fef79f1b56ee717b6d2611e649ff79e.jpg";